import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';


export default /*#__PURE__*/_defineComponent({
  props: {
  cols: {
    type: [String, Number, Object],
    default: undefined,
  },
  rows: {
    type: [String, Number, Object],
    default: undefined,
  },
  colGap: {
    type: [Number, String],
    default: 24,
  },
  rowGap: {
    type: [Number, String],
    default: 24,
  },
},
  setup(__props) {

const props = __props

const $q = useQuasar()



// Computed
const computedColumns = computed(() => {
  if (typeof props.cols === 'object') {
    if ($q.screen.xl && props.cols.xl) {
      return generateColumnsTemplate(props.cols.xl)
    } if ($q.screen.gt.md && props.cols.lg) {
      return generateColumnsTemplate(props.cols.lg)
    } else if ($q.screen.gt.sm && props.cols.md) {
      return generateColumnsTemplate(props.cols.md)
    } else if ($q.screen.gt.xs && props.cols.sm) {
      return generateColumnsTemplate(props.cols.sm)
    } else if (props.cols.xs) {
      return generateColumnsTemplate(props.cols.xs)
    }

    return null
  }

  return generateColumnsTemplate(props.cols)
})

const computedRows = computed(() => {
  if (typeof props.rows === 'object') {
    if ($q.screen.xl && props.rows.xl) {
      return generateRowsTemplate(props.rows.xl)
    } if ($q.screen.gt.md && props.rows.lg) {
      return generateRowsTemplate(props.rows.lg)
    } else if ($q.screen.gt.sm && props.rows.md) {
      return generateRowsTemplate(props.rows.md)
    } else if ($q.screen.gt.xs && props.rows.sm) {
      return generateRowsTemplate(props.rows.sm)
    } else if (props.rows.xs) {
      return generateRowsTemplate(props.rows.xs)
    }

    return null
  }

  return generateRowsTemplate(props.rows)
})

// Methods
function isNumeric (num) {
  return !isNaN(num)
}

function generateColumnsTemplate (template) {
  if (isNumeric(template)) {
    return `repeat(${template}, minmax(0, 1fr))`
  }

  return template
}

function generateRowsTemplate (template) {
  if (isNumeric(template)) {
    return `repeat(${template}, minmax(0, 1fr))`
  }

  return template
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "grid",
    style: _normalizeStyle({
      columnGap: `${__props.colGap}px`,
      rowGap: `${__props.rowGap}px`,
      gridTemplateColumns: _unref(computedColumns),
      gridTemplateRows: _unref(computedRows),
    })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})